import Psychologist from './psychologist.png';
import Abas from './abas.jpg';
import Agustina from './agustina.png';
import Ammy from './ammy.jpg';
import Andi from './andi.png';
import Angelia from './angelia.png';
import Ariesti from './ariesti.png';
import Ariani from './ariani.jpg';
import Astarini from './astarini.png';
import Aya from './aya.png';
import Bella from './bella.png';
import Diah from './diah.png';
import Dyah from './dyah.png';
import Hanina from './hanina.png';
import Irene from './irene.png';
import Ika from './ika.png';
import Livia from './livia.jpg';
import Mersedes from './mersedes.png';
import Niken from './niken.png';
import Prita from './prita.png';
import Rami from './rami.png';
import Raymond from './raymond.png';
import Rika from './rika.png';
import Susanti from './susanti.png';
import Shanen from './shanen.png';
import Shinta from './shinta.png';
import Silvia from './silvia.png';
import Sylvia from './sylvia.png';
import Upik from './upik.png';
import Viera from './viera.jpg';
import Widaningrum from './widaningrum.png';
import Wulan from './wulan.png';
import Wrenges from './wrenges.png';
import Yenny from './yenny.png';
import Frisca from './frisca.png';
import Prasti from './prasti.png';
import Veny from './veny.png';
import Nafisa from './nafisa.png';
import Fitra from './fitra.png';
import Nursila from './nursila.png';
import Madyastha from './madyastha.png';
import Inayah from './inayah.png';
import Alang from './alang.png';
import Maria from './maria.png';

const PsychologistImages = {
  Psychologist,
  Abas,
  Agustina,
  Ammy,
  Andi,
  Angelia,
  Ariesti,
  Ariani,
  Astarini,
  Aya,
  Bella,
  Diah,
  Dyah,
  Hanina,
  Irene,
  Ika,
  Livia,
  Mersedes,
  Niken,
  Prita,
  Rami,
  Raymond,
  Rika,
  Susanti,
  Shanen,
  Shinta,
  Silvia,
  Sylvia,
  Upik,
  Viera,
  Widaningrum,
  Wulan,
  Wrenges,
  Yenny,
  Frisca,
  Prasti,
  Veny,
  Nafisa,
  Fitra,
  Nursila,
  Madyastha,
  Inayah,
  Alang,
  Maria,
};

export default PsychologistImages;
